import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "./Sidebar";
import Chat from "./Chat";
import { LuBrain } from "react-icons/lu";
import UseToggle from "../Hooks/UseToggle";

const LLmNotebook = () => {
    const [collapsed, setCollapsed] = useState(false);
    const { toggle, setToggle, toggle1, setToggle1 } = UseToggle();
    const [selectedPdfId, setSelectedPdfId] = useState(null);
    const [readyPdfId, setReadyPdfId] = useState(null);
    const [readyPdfName, setReadyPdfName] = useState("");
    const [showUpload, setShowUpload] = useState("");

    return (
        <>
            <div className="header">
                <span className="fs_20 fw-bold">
                    <LuBrain className="fs_25" /> LLM Notebook
                </span>
            </div>

            <div className="body_content">
                <Container fluid>
                    <Row className="g-3">
                        <Col xs={12} lg={collapsed ? 1 : 3}>
                            <Sidebar
                                collapsed={collapsed}
                                setCollapsed={setCollapsed}
                                toggle={toggle}
                                setToggle={setToggle}
                                toggle1={toggle1}
                                setToggle1={setToggle1}
                                selectedPdfId={selectedPdfId}
                                setSelectedPdfId={setSelectedPdfId}
                                setShowUpload={setShowUpload}
                                showUpload={showUpload}
                                onEmbeddedSuccess={({ id, name }) => {
                                    setReadyPdfId(id);
                                    setReadyPdfName(name || "");
                                }}
                            />
                        </Col>

                        <Col xs={12} lg={collapsed ? 11 : 9}>
                            <Chat
                                showUpload={showUpload}
                                setShowUpload={setShowUpload}
                                selectedPdfId={selectedPdfId}
                                readyPdfId={readyPdfId}
                                readyPdfName={readyPdfName}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default LLmNotebook;
